/**
 * 异步翻译任务阈值
 * @description 当输入文本长度大于该阈值时，创建异步翻译任务
 */
export const ASYNC_THRESHOLD = 1000;

/**
 * 任务名称最大长度
 */
export const TITLE_MAX_LENGTH = 50;

/**
 * 翻译任务输入限制长度
 */
export const TRANSLATE_TASK_INPUT_LIMIT_LENGTH = 30000;

// 上传限制
export const GLOSSARY_LIMIT = 1000;

/**
 * 原文片段最大长度
 */
export const ORIGIN_FRAGMENT_MAX_LENGTH = 800;
